import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import enhance from './CompleteDealForm.enhancer';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import WarningIcon from '@material-ui/icons/Warning';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

class CompleteDealForm extends React.Component {
  constructor() {
    super();

    this.initialState = {
      contentUrl: '',
      embedString: '',
      errorMessage: '',
      addNewVideoIsOpen: false,
      linkIsValid: false,
      validateMessage: '',
      isSubmitContentModalOpen: false,
      isCompleteContentModalOpen: false,
      videoId: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  closeDrawer() {
    this.setState({
      ...this.initialState
    });
    this.props.closeClick();
  }

  contentFieldChangeHandler = e => {
    this.setState({
      contentUrl: e.target.value,
      verifyingLink: true
    });

    this.verifyContentLink();
  };

  handleClosePaymentModal() {
    this.setState({
      isSubmitContentModalOpen: false
    });
  }

  handleCloseCompleteModal() {
    this.setState({
      isCompleteContentModalOpen: false
    });
  }

  handleOpenCompleteModal() {
    this.setState({
      isCompleteContentModalOpen: true
    });
  }

  handleOpenPaymentModal() {
    this.setState({
      isSubmitContentModalOpen: true
    });
  }

  submitContentLink = () => {
    this.props.submitContentInformationHandler(
      this.state.contentUrl,
      this.state.embedString,
      this.props.deal.id,
      this.props.auth.uid
    );
    this.closeDrawer();
    this.setState({
      ...this.initialState
    });
  };

  getVideoIdFromLink() {
    const lastSlashIndex = this.state.contentUrl.lastIndexOf('/watch?v=');
    if (lastSlashIndex > 0) {
      return this.state.contentUrl.substring(lastSlashIndex + 1);
    }
    return '';
  }

  openAddNewVideo() {
    this.setState({
      addNewVideoIsOpen: !this.state.addNewVideoIsOpen
    });
  }

  completeContent() {
    this.props.completeContentHandler(this.props.deal.id, this.props.auth.uid);
    this.closeDrawer();
    this.setState({
      ...this.initialState
    });
  }

  verifyContentLink(e) {
    const url = e.target.value;
    this.setState({
      contentUrl: url,
      verifyingLink: true
    });
    if (url != undefined || url != '') {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length == 11) {
        // Do anything for being valid
        // if need to change the url to embed url then use below line
        // $('#ytplayerSide').attr('src', 'https://www.youtube.com/embed/' + match[2] + '?autoplay=0');
        this.setState({
          embedString: match[2],
          linkIsValid: true,
          validateMessage: '',
          verifyingLink: false
        });
      } else {
        this.setState({
          embedString: '',
          linkIsValid: false,
          validateMessage: 'Invalid youtube link',
          verifyingLink: false
        });
      }
    } else {
      this.setState({
        embedString: '',
        linkIsValid: false,
        validateMessage: 'Invalid youtube link',
        verifyingLink: false
      });
    }
  }

  render() {
    const { classes, open, deal } = this.props;
    const {
      contentUrl,
      addNewVideoIsOpen,
      linkIsValid,
      validateMessage,
      verifyingLink,
      embedString,
      isSubmitContentModalOpen,
      isCompleteContentModalOpen
    } = this.state;
    return (
      <React.Fragment>
        <Drawer
          onClose={this.closeDrawer.bind(this)}
          anchor="right"
          open={open}
        >
          <div className={classes.list} role="presentation">
            <Grid direction="column" className={classes.contentInputContainer}>
              <Grid>
                <ExpansionPanel
                  className={classes.expandPanel}
                  expanded={addNewVideoIsOpen}
                >
                  <Grid
                    item
                    className={classes.addNewVideoContainer}
                    onClick={() => this.openAddNewVideo()}
                  >
                    <AddCircleOutlineIcon className={classes.addIcon} />
                    <Typography variant="h6" display="inline">
                      Submit new video
                    </Typography>
                  </Grid>
                  <ExpansionPanelSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  />
                  <ExpansionPanelDetails>
                    <Grid item container direction="column" sm={12}>
                      <TextField
                        id="contentUrl"
                        name="contentUrl"
                        className={classes.contentInput}
                        variant="outlined"
                        placeholder="content link"
                        value={contentUrl}
                        onChange={this.verifyContentLink.bind(this)}
                      />
                      <Typography color="secondary">
                        {validateMessage}
                      </Typography>

                      {verifyingLink && (
                        <CircularProgress className={classes.downArrow} />
                      )}
                      {linkIsValid && !verifyingLink && (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth={true}
                            className={classes.submitButton}
                            onClick={this.handleOpenPaymentModal.bind(this)}
                          >
                            Submit Video
                          </Button>
                          <div className={classes.youtubeVideoUpload}>
                            <iframe
                              className={classes.iframeContainer}
                              src={`https://www.youtube.com/embed/${embedString}`}
                              frameborder="0"
                              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen
                            />
                          </div>
                        </React.Fragment>
                      )}
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
                {deal &&
                  deal.content &&
                  deal.content.length > 0 &&
                  deal.content.map(content => (
                    <Paper className={classes.contentContainer}>
                      <Typography>
                        Submitted on{' '}
                        {moment(content.timestamp.toDate()).format(
                          'MM/DD/YYYY'
                        )}
                      </Typography>
                      <Typography className={classes.contentLinkContainer}>
                        <a
                          target="_blank"
                          href={content.contentLink}
                          className={classes.contentLink}
                        >
                          {content.contentLink}
                        </a>
                      </Typography>
                    </Paper>
                  ))}
              </Grid>
              <div className={classes.submitButtonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth={true}
                  className={classes.completeButton}
                  onClick={() => this.handleOpenCompleteModal()}
                >
                  Complete Deal
                </Button>
              </div>
            </Grid>
          </div>
        </Drawer>
        <Dialog
          id="payment-info-dialog"
          open={isSubmitContentModalOpen}
          onClose={this.handleClosePaymentModal.bind(this)}
          disableAutoFocus={true}
          onBackdropClick={this.handleClosePaymentModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="h6" align="center" justify="center">
            Submit Video
          </Typography>
          <Grid className={classes.warningMessage}>
            <WarningIcon className={classes.warningIcon} />
            <Typography display="inline" className={classes.messageText}>
              You will not be able to remove a video once you have added it
            </Typography>
          </Grid>
          <Grid>
            <WarningIcon className={classes.warningIcon} />
            <Typography display="inline" className={classes.messageText}>
              Your video will be able to be viewed as soon as you add them
            </Typography>
          </Grid>
          <Grid className={classes.acceptButtonContainer}>
            <Button
              color="secondary"
              onClick={() => this.handleClosePaymentModal()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.acceptSubmitButton}
              onClick={() => this.submitContentLink()}
            >
              Submit
            </Button>
          </Grid>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default enhance(CompleteDealForm);



// WEBPACK FOOTER //
// ./src/components/deals/complete-deal-form/CompleteDealForm.js